import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useExportDataBl } from '../../ExportData.bl';
import { ExportDataFilter } from '../../models/ExportDataFilter';
import { ProjectExportDropdown } from './ProjectExportDropdown';

interface IProps {
  projectExportId: string;
  hasAllFilesGenerated: boolean;
}

export const ProjectExportDropdownContainer = observer((props: IProps): ReactElement => {
  const bl = useExportDataBl();

  const handleAllDownloadClick = (): void => {
    bl.showDownloadModal(props.projectExportId, ExportDataFilter.ALL);
  };

  const handleAcceptedDownloadClick = (): void => {
    bl.showDownloadModal(props.projectExportId, ExportDataFilter.ACCEPTED);
  };

  const handleAnnotatedDownloadClick = (): void => {
    bl.showDownloadModal(props.projectExportId, ExportDataFilter.ANNOTATED);
  };

  const handleConfigDownloadClick = (): void => {
    bl.showDownloadModal(props.projectExportId, ExportDataFilter.CONFIG_ONLY);
  };

  return (
    <ProjectExportDropdown
      hasAllFilesGenerated={props.hasAllFilesGenerated}
      onAllDownloadClick={handleAllDownloadClick}
      onAcceptedDownloadClick={handleAcceptedDownloadClick}
      onAnnotatedDownloadClick={handleAnnotatedDownloadClick}
      onConfigDownloadClick={handleConfigDownloadClick}
    />
  );
});
